import { RouteInfo } from './vertical-menu.metadata';

//Sidebar menu Routes and data para conferidores
export const CONFERIDORROUTES: RouteInfo[] = [
  {
    path: '/page/conferidor/municipios', title: 'Municípios', icon: 'ft-building', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
];












